import React from 'react';
import cx from 'classnames';

/**
 * @typedef {object} ErrorMessageProps
 * @property {string} [message]
 * @property {string} [className]
 * @property {string} [dataTestId]
 */

/**
 * @param {ErrorMessageProps} props
 */
const ErrorMessage = props => {
  const { message, className, dataTestId = '' } = props;

  return (
    <p
      data-testid={dataTestId}
      className={cx('form-input-error-message', { [className]: className })}>
      {message}
    </p>
  );
};

export default ErrorMessage;
